<template>
	<div>
		<el-row class="contents">
			<el-col>
				<el-descriptions title="设备信息" :column="3" style="width:1200px">
					<el-descriptions-item label="设备编号">{{device.code}}</el-descriptions-item>
					<el-descriptions-item label="设备名称">{{device.title}}</el-descriptions-item>
					<el-descriptions-item label="关联标签">
						<el-tag v-for="(tag,index) in JSON.parse(device.tags)" :key="index" style="margin-top:-4px">
							{{tag}}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="设备定位">
						{{device.provinceName}}-{{device.cityName}}
					</el-descriptions-item>
					<el-descriptions-item label="化学品" :span="2">
						<div class="recipe_content" style="margin-top: -4px;">
							<el-select v-model="recipeData.type1" style="width:150px" size="mini" :clearable="true" filterable placeholder="#1 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<el-select v-model="recipeData.type2" style="width:150px" size="mini" :clearable="true" filterable placeholder="#2 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<el-select v-model="recipeData.type3" style="width:150px" size="mini" :clearable="true" filterable placeholder="#3 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<br/>
							<el-select v-model="recipeData.type4" style="width:150px;margin-top:5px;" size="mini" :clearable="true" filterable placeholder="#4 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<el-select v-model="recipeData.type5" style="width:150px;margin-top:5px;" size="mini" :clearable="true" filterable placeholder="#5 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<el-select v-model="recipeData.type6" style="width:150px;margin-top:5px;" size="mini" :clearable="true" filterable placeholder="#6 代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							<el-button type="primary" size="mini" @click="updateConfig">更新</el-button>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="设备描述">
						<el-input disabled type="textarea" :autosize="{ minRows: 3}" style="width: 300px;" v-model="device.description"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="创建人">{{device.creatorName}}</el-descriptions-item>
					<el-descriptions-item label="创建时间">{{device.createTime}}</el-descriptions-item>
				</el-descriptions>
			</el-col>
			</el-col>

		</el-row>

		<el-row>
			<el-menu :default-active="activeIndex" class="el-menu" mode="horizontal" @select="handleClick" text-color="#409eff" active-text-color="#0368D0">
				<el-menu-item :index="index+''" v-for="(tag,index) in allTags" :key="index">{{tag}}</el-menu-item>
			</el-menu>
			<el-row class="contents">
				<!-- 查询条件 -->
				<el-col :span="24" class="handleQuery">
					<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="78px">
						<el-form-item label="全部状态">
							<el-select v-model="queryParams.alarmState" placeholder="请选择状态">
								<el-option label="全部" value=""></el-option>
								<el-option label="报警" :value="2"></el-option>
								<el-option label="正常" :value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="选择变量">
							<el-select ref="templateVariable" v-model="queryParams.variableId" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
								:loading="templateVariableLoading" @focus="templateVariableSelectFocus" @blur="templateVariableSelectBlur" :clearable="true" collapse-tags
								@clear="templateVariableSelectClear">
								<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
							<el-button type="primary" size="small" @click="handleBatchCollect" v-has="'btn_collect'">全部主动采集</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!-- 列表 -->
				<el-col :span="24">
					<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark"
						@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
						<el-table-column fixed type="selection" width="55"></el-table-column>
						<el-table-column prop="variableTitle" label="变量名称">
							<template slot-scope="scope" >
								<el-button type="text" style="font-size:18px">{{scope.row.variableTitle}}</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="variableShowValue" label="当前值">
							<template slot-scope="scope">
								<div style="font-size:18px;color:#000000">
									{{scope.row.variableShowValue}}
									<span v-if="scope.row.variableShowValue&&scope.row.unit">{{scope.row.unit}}</span>
									<i class="el-icon-edit" v-if="hasAuth('btn_update_value')&&scope.row.readWriteType=='read_write'" @click="handleEdit(scope.row)"></i>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="updateTime" label="更新时间"></el-table-column>
						<el-table-column prop="tags" label="变量分组">
							<template slot-scope="scope" v-if="scope.row.variableTags">
								<el-tag v-for="(tag,index) in JSON.parse(scope.row.variableTags)" :key="index" type="">
									{{tag}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" :width="width" v-if="width>0">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="goHistory(scope.row)" v-has="'btn_query_history'">历史查询</el-button>
								<el-button size="mini" type="text" @click="handleCollect(scope.row)" v-has="'btn_collect'">主动采集</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
						:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
				</el-col>
			</el-row>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="addOrUpdateForm.variableTitle" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="70px">
				<el-form-item label="变量值" prop="variableShowValue">
					<el-input type="text" v-model="addOrUpdateForm.variableShowValue" placeholder="请输入变量值"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdateValue()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="修改化学品名称" :visible.sync="dialogConfigVisible" width="400px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="configRules" ref="addOrUpdateForm" label-width="100px">
				<el-form-item label="化学品名称" prop="title">
					<el-input type="text" v-model="addOrUpdateForm.title" placeholder="请输入化学品名称"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogConfigVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="updateOneConfig()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import eventBus from '@/components/libs/eventBus.js';
	import common from '@/common/common.js';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				chemicalsList: [],
				variableTag: "",
				queryParams: {
					variableId:"",
					variableTitle:"",
					defaultSort: {
						order: null,
						prop: ''
					}
				},
				dialogAddTriggerVisible: false,
				dialogListVisible: false,
				translateParams: {},
				allTags: [],
				activeIndex: "0",
				tags: [],
				fileList: [],
				hashBack: false,
				url: 'device/variable/value',
				name: '变量',
				dialogSendVisible: false,
				dialogVariableVisible: false,
				importData: {},
				headers: {},
				intervalId: null,
				row: {},
				dialogBatchSendVisible: false,
				variableValues: [],
				groupList: [],
				currGroup: null,
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				autoQuery: false,
				rules: {
					variableShowValue: [{
						required: true,
						message: '请输入变量值',
						trigger: 'blur'
					}]
				},
				configList: [],
				dialogConfigVisible:false,
				configRules: {
					title: [{
						required: true,
						message: '请输入化学品名称',
						trigger: 'blur'
					}]
				},
				recipeData:{
					
				}
			};
		},
		filters: {
			formatSaveType(dataType) {
				if ("change" == dataType) {
					return "变化存储";
				} else {
					return "全部存储"
				}
			},
			formatRate(rate) {
				if (rate >= 60 * 24) {
					return (rate / 60 / 24) + "天"
				} else {
					return rate + "分钟"
				}
			},
			formatReadWriteType(readWriteType) {
				if ("read_only" == readWriteType) {
					return "只读";
				} else if ("read_write" == readWriteType) {
					return "读写";
				}
				return "";
			},
			formatReceiveData(row) {
				if (row.status == 0) {
					return "未开始"
				} else if (row.status == 1) {
					return "获取中..."
				} else {
					return row.receiveData
				}
			},
			formatRegister(row) {
				if (!row.primaryAddress) {
					return row.registerType
				} else {
					var register = "";
					if ((row.primaryAddress + "").length < 4) {
						register = row.registerType * 1000 + row.primaryAddress
					} else {
						register = row.registerType + "" + row.primaryAddress
					}
					if (row.dataType == 'bit' && row.secondaryAddress) {
						register += "." + row.secondaryAddress
					}
					return register
				}
			}
		},
		methods: {
			setDevice(device) {
				this.device = device;
			},
			back() {
				common.routerPush(this, '/front/device/template')
			},
			beforeQuery() {
				if(this.queryParams.variableTags=="全部"){
					this.queryParams.variableTags=""
				}
				this.queryParams.deviceId = this.device.id
			},
			getQueryParams(){
				var query = JSON.parse(JSON.stringify(this.queryParams))
				if(query.variableId){
					if(this.templateVariableList==null || this.templateVariableList.filter(item=>item.id==query.variableId)==null){
						query.variableId =""
					}else if(query.variableId == query.variableTitle){
						query.variableId=""
					}
				}
				return query;
			},
			beforeEdit(isEdit) {
				this.tags = []
				if (isEdit && this.addOrUpdateForm.tags) {
					this.tags = JSON.parse(this.addOrUpdateForm.tags)
				}
			},
			templateVariableSelectFocus() {
				this.queryTemplateVariableList()
			},
			templateVariableSelectBlur(){
				this.queryParams.variableTitle = this.$refs.templateVariable.selectedLabel
				this.queryParams.variableId = this.$refs.templateVariable.selectedLabel
				 this.$forceUpdate(); 
			},
			templateVariableSelectClear(){
				this.queryParams.variableTitle = ""
				this.queryParams.variableId = ""
				this.$forceUpdate(); 
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.device.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.device.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
				}
			},
			queryTags() {
				this.$http({
					method: 'POST',
					url: 'template/variable/queryTags?templateId=' + this.device.templateId,
					data: {},
				}).then((res) => {
					if (res.data.data) {
						res.data.data.unshift("全部");
						res.data.data.push("其他")
						this.allTags = res.data.data;
					} else {
						this.allTags = ["全部","其他"];
					}
					this.handleClick(0)
				})
			},
			handleCollect(row) {
				this.$confirm('您将要主动采集变量：' + row.variableTitle + '，是否继续？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$http({
							method: 'POST',
							url: 'template/variable/collect',
							data: {
								"deviceId": this.device.id,
								"ids": [row.variableId]
							},
						}).then((res) => {
							this.successMessage('提示', '发送采集信息成功');
						})
					})
			},
			handleUpdateValue() {
				//添加/保存
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						let that = this;
						this.$http({
								method: 'POST',
								url: 'template/variable/updateValue',
								data: {
									id: that.addOrUpdateForm.variableId,
									value: that.addOrUpdateForm.variableShowValue,
									deviceId: this.device.id
								}
							})
							.then(function(res) {
								that.successMessage('系统提示', '修改中...');
								that.dialogVisible=false;
							});
					} else {
						return false;
					}
				});
			},
			handleBatchCollect(row) {
				if (this.multipleSelection.length == 0) {
					this.$message({
						message: '请选择要采集的数据',
						type: 'warning'
					});
					return;
				}
				var ids = [];
				this.multipleSelection.forEach(item => {
					ids.push(item.variableId);
				});
				this.$confirm('您将要采集' + ids.length + '个变量, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$http({
							method: 'POST',
							url: 'template/variable/collect',
							data: {
								"deviceId": this.device.id,
								"ids": ids
							},
						}).then((res) => {
							this.successMessage('提示', '发送采集信息成功');
						})
					})
			},
			goHistory(row) {
				this.$emit('goHistory', {
					variableId: row.variableId,
					variableTitle: row.variableTitle
				});
			},
			handleClick(tab, event) {
				this.queryParams.variableTags = this.allTags[parseInt(tab)]
				this.handleQuery()
			},
			queryConfigList() {
				this.$http({
					method: 'GET',
					url: 'mngr/chemicals/device/recipe/detail?deviceId=' + this.device.id,
					data: {},
				}).then((res) => {
					this.recipeData = res.data.data;
				})
			},
			handleEditConfig(row){
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.beforeEdit(true);
				this.dialogConfigVisible=true;
			},
			updateOneConfig(){
				if (this.addOrUpdateForm.checked == 1) {
					this.addOrUpdateForm.state = 1;
				} else {
					this.addOrUpdateForm.state = 0;
				}
				this.updateConfig([this.addOrUpdateForm])
			},
			updateConfig(params) {
				this.recipeData.deviceId = this.device.id;
				this.$http({
					method: 'POST',
					url: 'mngr/chemicals/device/recipe/update',
					data: this.recipeData,
				}).then((res) => {
					this.successMessage('更新成功')
					this.queryConfigList()
				})

			},
			queryAllChemicals() {
				this.$http({
					method: 'POST',
					url: 'mngr/chemicals/query',
					data: {
						currentPage: 1,
						pageSize: 10000,
						state:1,
						institutionId: this.device.institutionId
					},
				}).then((res) => {
					this.chemicalsList = res.data.data;
				})
			},
		},
		mounted: function() {
			this.queryTags();
			this.queryConfigList()
			this.queryAllChemicals();
			if (this.$route.query.templateId) {
				this.hashBack = true;
				this.queryParams.templateId = this.$route.query.templateId;
				this.addOrUpdateForm.templateId = this.$route.query.templateId;
			}
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
			eventBus.$on('message:1', (data) => {
				if (data.deviceId == this.device.id) {
					data.valueList.forEach(item => {
						this.datas.forEach(row => {
							if (item.id == row.variableId) {
								row["variableShowValue"] = item["value"]
								row["updateTime"] = item["updateTime"]
								row["status"] = item["status"]
								row["errorMessage"] = item["errorMessage"]
							}
						});
					});
				}
			})
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.el-tag {
		margin: 0px 8px 5px 0px;
		padding: 0 5px;
	}

	.contents {
		padding-left: 10px;
		padding-top: 10px;
	}

	.form {
		margin: 0px;
	}

	.device_info {
		margin-bottom: 10px;
	}

	.device_label {
		width: 70px;
		float: left;
	}

	.el-icon-edit {
		cursor: pointer;
	}
	.recipe_content .el-select .el-input {
		width:100px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/deviceInfo.vue